<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center mb-1">
      <div>
        <h1 class="font-weight-bold" style="font-size: 2em;">Configurações do Sistema</h1>
        <div class="subtitle-2" style="color: #666;">Gerencie as configurações gerais do Fisio Conecta</div>
      </div>
    </div>
    <div class="mb-6 mt-6 pa-4">
      <!-- <v-btn block large class="botao-config mb-4" color="primary" style="border-radius: 4px; font-size: 1.1em;">
        <v-icon left class="mr-2">mdi-lock-plus</v-icon>
        CADASTRAR SMARTLOCK
      </v-btn>
      <v-btn block large class="botao-config mb-4" color="red lighten-1" style="border-radius: 4px; font-size: 1.1em; color: white;">
        <v-icon left class="mr-2">mdi-hand-left</v-icon>
        PARAR SMARTLOCK
      </v-btn> -->
      <v-btn block large @click="dialogWhatsapp = true" class="botao-config mb-4" color="success" style="border-radius: 4px; font-size: 1.1em; color: white;">
        <v-icon left class="mr-2">mdi-whatsapp</v-icon>
        MENSAGENS WHATSAPP
      </v-btn>
      <v-btn block large @click="dialogEspecialidade = true" class="botao-config mb-4" color='blue' style="border-radius: 4px; font-size: 1.1em; color: white;">
        <v-icon left class="mr-2">mdi-</v-icon>
        CADASTRAR ESPECIALIDADES
      </v-btn>
      <v-btn block large @click="dialogAdministrador = true" class="botao-config mb-4" color='blue' style="border-radius: 4px; font-size: 1.1em; color: white;">
        <v-icon left class="mr-2">mdi-</v-icon>
        CADASTRAR NOVO ADMINISTRADOR
      </v-btn>
      <!-- <v-btn block large class="botao-config mb-4" color="orange" style="border-radius: 4px; font-size: 1.1em; color: white;">
        <v-icon left class="mr-2">mdi-account-check</v-icon>
        ATIVAÇÃO DE FISIOTERAPEUTAS AUTOMÁTICA
      </v-btn> -->
    </div>
    <v-dialog v-model="dialogAdministrador" v-if="dialogAdministrador" width="40em">
      <dialog-administrador
        @fechar="dialogAdministrador = false"
        @success="showInfo"
        @error="showError"
      />
    </v-dialog>
    <v-dialog v-model="dialogEspecialidade" v-if="dialogEspecialidade" width="40em">
      <dialog-especialidade
        @fechar="dialogEspecialidade = false"
        @success="showInfo"
        @error="showError"
      />
    </v-dialog>
    <v-dialog v-model="dialogWhatsapp" v-if="dialogWhatsapp" width="50em">
      <dialog-send-zapi @fechar="dialogWhatsapp = false"/>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
      >
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import DialogSendZapi from '@/components/dialogs/SendZapi.vue'
import DialogEspecialidade from '@/components/dialogs/dialogEspecialidade.vue'
import DialogAdministrador from '@/components/dialogs/dialogAdministrador.vue'

export default {
  name: 'ConfiguracoesSistema',
  components: { DialogSendZapi, DialogEspecialidade, DialogAdministrador },
  data() {
    return {
      dialogWhatsapp: false,
      dialogEspecialidade: false,
      dialogAdministrador: false,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
    }
  },
  methods: {
    showInfo(info) {
      this.snackbar.color = 'success'
      this.snackbar.text = info
      this.snackbar.active = true
    },
    showError(error) {
      this.snackbar.color = 'error'
      this.snackbar.text = error
      this.snackbar.active = true
    }
  }
}
</script>

<style scoped>
.v-btn {
  text-transform: none !important;
}
</style>